import { find } from "lodash";
// 格式化日期
export const formatDate = (value, fmt = "yyyy-MM-dd hh:mm:ss") => {
  if (!value) {
    return "";
  }
  let getDate = new Date(value * 1);
  let o = {
    "M+": getDate.getMonth() + 1,
    "d+": getDate.getDate(),
    "h+": getDate.getHours(),
    "m+": getDate.getMinutes(),
    "s+": getDate.getSeconds(),
    "q+": Math.floor((getDate.getMonth() + 3) / 3),
    S: getDate.getMilliseconds(),
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
};

// 分类生成树形结构数据
export const formatCategories = (category) => {
  const cate = {
    value:
      category.categoryInfo != null ? category.categoryInfo.categoryId : "",
    label:
      category.categoryInfo != null ? category.categoryInfo.categoryName : "",
    categoryInfo: category.categoryInfo,
  };
  if (category.children) {
    const children = [];
    category.children.map((item) => {
      item = formatCategories(item);
      children.push(item);
    });
    if (children.length) {
      cate.children = children;
    }
  }
  return cate;
};

// 列表数据转化成 SELECT 格式
export const changeOptions = (stateMap) => {
  const stateOptions = [];
  for (const key in stateMap) {
    if (stateMap.hasOwnProperty(key)) {
      stateOptions.push({
        label: stateMap[key],
        value: key,
      });
    }
  }
  return stateOptions;
};
// expo;

export const dateQueue = (rangeType = "SEVEN_DAYS_AGO", date) => {
  // 当天时间戳
  const time = new Date().getTime();
  // 当时日期
  const nowDate = formatDate(time, "yyyy-MM-dd");
  const dateTime = new Date(nowDate + " 00:00:00");
  const dayTime = 1000 * 60 * 60 * 24;
  const dateArray = [];
  const d = new Date().getDate();
  const y = new Date().getFullYear();
  const m = new Date().getMonth() + 1;
  // 如果是近七天
  if (rangeType == "SEVEN_DAYS_AGO") {
    for (let i = 1; i <= 7; i++) {
      dateArray.unshift(formatDate(dateTime - dayTime * i, "yyyy-MM-dd"));
    }
  } else if (rangeType == "MONTH" || (!rangeType && date instanceof Array)) {
    // 获取当前月份第一天
    let startTime = new Date(y + "-" + m + "-" + "01" + " 00:00:00").getTime();
    let endTime = dateTime.getTime();
    if (!rangeType && date instanceof Array) {
      startTime = new Date(date[0] + " 00:00:00").getTime();
      endTime = new Date(date[1] + " 00:00:00").getTime();
    }
    while (startTime <= endTime) {
      dateArray.push(formatDate(startTime, "yyyy-MM-dd"));
      startTime += dayTime;
    }
  } else if (rangeType == "YEAR") {
    const monthArr = [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月",
    ];
    for (let i = 0; i < m; i++) {
      dateArray.push(monthArr[i]);
    }
  }
  return dateArray;
};

// 判断是否是工作日，并获取往后三天工作日
export const validateSupplyPriceDate = (time, timerange) => {
  const day = 1000 * 60 * 60 * 24;
  const m = time.getMonth();
  const d = time.getDate();
  const w = time.getDay();
  var beginTime = Date.now();
  // 非工作日禁止
  if (w == 6 || w == 0) {
    return true;
  }
  // 往后退3个工作日
  let i = 0;
  while (i < timerange) {
    beginTime += day;
    let time = new Date(beginTime);
    let w = time.getDay();
    if (w !== 6 && w !== 0) {
      i++;
    }
  }
  return time.getTime() < beginTime;
};
